import LOCATIONS from "@/data/locations.yml";
import ContentBlock from "@/components/content-block";
import dynamicLocalization from "@/mixins/dynamic-localization";

export default {
  components: { ContentBlock },
  mixins: [dynamicLocalization],
  data() {
    return {
      LOCATIONS,
    };
  },
};
